import { createContext } from 'react';

import { defaultXAxis } from '../constants/defaults.js';
import { HistogramChartXAxisConfig } from '../types/histogram.js';

export const HistogramXAxisConfigContext =
  createContext<HistogramChartXAxisConfig>(defaultXAxis);

HistogramXAxisConfigContext['displayName'] = 'HistogramXAxisConfigContext';
